/**
 * Dubbing & Adaptation service page
 * Changed blue buttons to orange for brand alignment
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Mic, CheckCircle } from 'lucide-react'

export default function DubbingPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-pink-900 via-pink-800 to-rose-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Dubbing & Adaptation</h1>
              <p className="text-xl text-pink-100 leading-relaxed mb-8">
                Professional audio-visual localization services for international and regional campaigns, 
                ensuring your message resonates perfectly with local audiences.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Localize Your Content</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/a73a65c0-c4ac-47d5-8c82-cd7c8994b01d.jpg" 
                alt="Dubbing Studio"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Dubbing Services</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-pink-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Professional Voice Acting</h3>
                    <p className="text-gray-600">Native speakers with perfect pronunciation and emotion</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-pink-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Cultural Adaptation</h3>
                    <p className="text-gray-600">Ensuring content fits local cultural context</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-pink-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Studio Quality Production</h3>
                    <p className="text-gray-600">Professional recording and post-production services</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-pink-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Multiple Languages</h3>
                    <p className="text-gray-600">Arabic, Kurdish (Sorani & Badini), English</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/7471bc94-835c-4863-9a8c-4052a26ecdfd.jpg" 
                alt="Voice Recording"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-pink-900 to-rose-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Speak Every Language?</h2>
          <p className="text-xl text-pink-100 mb-8">
            Let us help you localize your content for perfect cultural resonance and engagement
          </p>
          <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600 text-lg px-8">
            <Link to="/contact">Start Dubbing Project</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
